// OrderX Blue is the dark theme on the brand's navy page. next-themes keeps plain `dark` (so
// every theme branch, TradingView included, holds); the tint rides alongside in its own key and
// only applies to dark. Blue is the default: only an explicit plain Dark pick in settings
// (stored as `ink`) opts out. Light is always plain.
const PAGE_TINT_KEY = 'page-tint'

export type PageTint = 'ink' | 'blue'

export function readPageTint(): PageTint {
  try {
    return localStorage.getItem(PAGE_TINT_KEY) === 'ink' ? 'ink' : 'blue'
  } catch {
    return 'blue'
  }
}

export function writePageTint(tint: PageTint) {
  try {
    localStorage.setItem(PAGE_TINT_KEY, tint)
  } catch {
    // Storage blocked: the tint just won't survive a reload.
  }
}

export function applyPageTheme(theme: string | undefined, tint: PageTint = readPageTint()) {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  const pageTheme = theme === 'dark' ? 'dark' : 'light'
  root.dataset.pageTheme = pageTheme
  if (pageTheme === 'dark' && tint === 'blue') root.dataset.pageTint = 'blue'
  else delete root.dataset.pageTint
}
